import { Palette, Sparkles, ShieldCheck } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const CARDS = [
  {
    icon: Palette,
    title: "Beautiful, Professional Design",
    text: "Websites that make an excellent first impression and reflect the quality of your business.",
    id: "design",
  },
  {
    icon: Sparkles,
    title: "Simple, Stress-Free Process",
    text: "We handle the technical details so you don't have to.",
    id: "process",
  },
  {
    icon: ShieldCheck,
    title: "We Handle the Ongoing Work",
    text: "Hosting, technical upkeep, and ongoing website care are available through our monthly service.",
    id: "ongoing",
  },
];

const WhyUs = () => (
  <section id="why-us" data-testid="why-choose-us-section" className="relative bg-cream py-20 md:py-28 lg:py-32">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="max-w-2xl">
        <p className="text-xs font-sans uppercase tracking-[0.28em] font-semibold text-turquoise-deep mb-5 flex items-center gap-3">
          <span className="w-10 h-px bg-turquoise inline-block" />
          Why Choose Us
        </p>
        <h2 className="font-serif font-medium tracking-tight text-charcoal text-2xl sm:text-3xl lg:text-4xl leading-tight">
          A website partner, not another <span className="italic text-turquoise">to-do list.</span>
        </h2>
        <p className="mt-5 text-base font-sans text-taupe leading-relaxed">
          You didn't start your business to learn website technology. We make the entire experience
          simple — and the result beautiful.
        </p>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {CARDS.map((c, i) => (
          <Reveal key={c.id} delay={i * 0.1}>
            <div
              data-testid={`why-card-${c.id}`}
              className="group h-full bg-cream-dark border border-taupe/15 rounded-2xl p-8 md:p-10 shadow-[0_10px_30px_rgba(0,0,0,0.03)] hover:border-turquoise/50 hover:-translate-y-1.5 transition-[border-color,transform,box-shadow] duration-300 hover:shadow-[0_20px_40px_-12px_rgba(0,175,163,0.18)]"
            >
              <div className="w-12 h-12 rounded-full bg-turquoise/10 border border-turquoise/30 flex items-center justify-center mb-6 group-hover:bg-turquoise group-hover:border-turquoise transition-colors duration-300">
                <c.icon size={20} className="text-turquoise-deep group-hover:text-charcoal transition-colors duration-300" strokeWidth={1.75} />
              </div>
              <h3 className="font-serif font-medium text-xl text-charcoal leading-snug mb-3">
                {c.title}
              </h3>
              <p className="font-sans text-sm text-taupe leading-relaxed">{c.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default WhyUs;
